<div class="col-sm-12 coldx" >
	<h4>{{title}}</h4>
	<ng-template [ngIf]="calcoloInteressiForm">
	<form [formGroup]="calcoloInteressiForm" (ngSubmit)="save();">
		<div class="row">
			<div datePickerInput class="col-sm-4 col-sm-offset-4"
			[labelInput]="getLabel()"
			formControlName="dataInizioCalcolo"
			[(ngModel)]="dataInizioCalcoloNumber"></div>
		</div>

		<div class="row">
			<p class="mandatory col-sm-12">
				<em>* Campi obbligatori</em>
			</p>
		</div>

		<div class="row">
			<div class="col-sm-3 col-xs-6">
				<p>
					<button type="button" class="btn btn-outline-secondary btn-block"
						(click)="createForm();">Reset</button>
				</p>
			</div>
			<div class="col-sm-3 col-xs-6 col-sm-offset-6">
				<p submitButton [labelButton]="'Salva'"></p>
			</div>
		</div>
	</form>
	</ng-template>
</div>
